
export const sanitizeData = (data) => {
	return Object.fromEntries(
		Object.entries(data).filter(([_, value]) => value !== undefined)
	);
}

/**
 * Formats a duration in seconds into MM:SS format.
 * @param {number} totalSeconds - The total duration in seconds.
 * @returns {string} The formatted time string (e.g., "05:30").
 */
export const formatTimeMMSS = (totalSeconds) => {
	if (typeof totalSeconds !== 'number' || totalSeconds < 0) {
		return '00:00'; // Return default for invalid input
	}
	const minutes = Math.floor(totalSeconds / 60);
	const seconds = totalSeconds % 60;
	const formattedMinutes = String(minutes).padStart(2, '0');
	const formattedSeconds = String(seconds).padStart(2, '0');
	return `${formattedMinutes}:${formattedSeconds}`;
}

/**
 * Level management functions have been moved to levelManager.js
 * Import from '../utilities/levelManager' instead:
 * - isValidQuebecLevel
 * - levelToQuebecScale
 * - normalizeLevel
 * - isValidLevel
 */